'use client';

import { useRef } from 'react';

import { useElementHeight } from '@/app/lib/hooks/use-element-height';
import { TextLayout } from '@/components/text-layout';

import { HALF_MOBILE_IMAGE_HEIGHT, HeroImage } from '../hero-image';

import type { Hero as Props } from '@/app/generated/graphql';

export const Hero = ({
  heading,
  body,
  image,
  primaryButton,
  mobileImage,
}: Pick<
  Props,
  'heading' | 'body' | 'image' | 'primaryButton' | 'mobileImage'
>) => {
  const formRef = useRef<HTMLDivElement>(null);
  const formHeight = useElementHeight(formRef);

  return (
    <div className="bg-gray-50">
      <div className="pb-c pt-d md:container sm:py-c md:py-c">
        <div className="grid relative sm:min-h-[420px] md:ml-0 md:min-h-[460px] md:grid-cols-12 lg:min-h-[480px]">
          <HeroImage
            formHeight={formHeight}
            image={image}
            mobileImage={mobileImage}
          />
          <div
            style={{
              marginTop:
                formHeight < HALF_MOBILE_IMAGE_HEIGHT
                  ? HALF_MOBILE_IMAGE_HEIGHT - formHeight
                  : 0,
            }}
            className="z-10 col-span-11 mb-[210px] flex rounded-l-rad-b md:col-span-11 md:col-start-2 md:mb-0 md:ml-c md:mt-0 md:min-h-[460px] md:items-center md:rounded-rad-b md:bg-none lg:min-h-[480px]"
            ref={formRef}
          >
            <div className="mx-e flex flex-col items-center rounded-rad-a bg-white px-e py-f text-center shadow md:mx-0 md:ml-[calc(((-1/12)*100%)-0.75rem)] md:w-[calc((10/12)*100%)] md:max-w-[550px] md:items-start md:rounded-rad-b md:px-d md:py-e md:text-left lg:w-[calc((5/12)*100%+24px)] xl:w-[calc((5/12)*100%+28px)]">
              <TextLayout
                body={body}
                heading={heading}
                primaryButton={primaryButton}
                headingVariant="h2"
                headingElement="h1"
                headingAccent="responsive"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
